/* Listings AJAX filters */
(function () {
	'use strict';

	var form = document.getElementById('btr-listing-filters');
	var grid = document.getElementById('btr-listings-grid');
	if (!form || !grid || typeof btrListings === 'undefined' || window.__btrListingsInit) {
		return;
	}
	window.__btrListingsInit = true;

	var sortEl = document.getElementById('btr-f-sort');
	var countEl = document.getElementById('btr-results-count');
	var pagination = document.getElementById('btr-listings-pagination');
	var resetBtn = document.getElementById('btr-reset');

	var initialPage = parseInt(new URLSearchParams(window.location.search).get('paged'), 10);
	var page = initialPage > 0 ? initialPage : 1;
	var controller = null;
	var timer = null;

	function skeletonCard() {
		return (
			'<article class="btr-skel-card" aria-hidden="true">' +
			'<span class="btr-skel-media"></span>' +
			'<div class="btr-skel-info">' +
			'<span class="btr-skel-line btr-skel-line--title"></span>' +
			'<span class="btr-skel-line btr-skel-line--meta"></span>' +
			'<span class="btr-skel-line btr-skel-line--price"></span>' +
			'<span class="btr-skel-line btr-skel-line--date"></span>' +
			'<span class="btr-skel-badge"></span>' +
			'</div>' +
			'</article>'
		);
	}

	function showSkeleton(count) {
		var html = '';
		var n = count || 6;
		for (var i = 0; i < n; i++) {
			html += skeletonCard();
		}
		grid.innerHTML = html;
	}

	function clearSkeleton() {
		var skeletons = grid.querySelectorAll('.btr-skel-card');
		for (var i = 0; i < skeletons.length; i++) {
			skeletons[i].parentNode.removeChild(skeletons[i]);
		}
	}

	function buildParams(paged) {
		var params = new URLSearchParams(new FormData(form));
		params.set('sort', sortEl ? sortEl.value : 'price_asc');
		params.set('paged', paged);
		params.set('action', btrListings.action);
		return params;
	}

	function load(targetPage) {
		// Purani pending request cancel karo (race condition se bachne ke liye).
		if (controller) {
			controller.abort();
		}
		var requestController = new AbortController();
		controller = requestController;

		targetPage = Math.max(1, parseInt(targetPage, 10) || 1);
		grid.classList.add('is-loading');
		grid.setAttribute('aria-busy', 'true');
		showSkeleton(6);

		fetch(btrListings.ajaxUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
			body: buildParams(targetPage).toString(),
			signal: requestController.signal
		})
			.then(function (res) {
				return res.json();
			})
			.then(function (json) {
				if (!json || !json.success) {
					throw new Error('Request failed');
				}
				var data = json.data;

				// Agar requested page maujood nahi (filters ke baad results kam ho gaye), to page 1 load karo.
				if (data.max_pages > 0 && targetPage > data.max_pages) {
					load(1);
					return;
				}
				clearSkeleton();
				grid.innerHTML = data.html;
				page = targetPage;
				if (countEl) {
					countEl.textContent = data.label;
				}
				if (pagination) {
					pagination.innerHTML = data.pagination;
					pagination.style.display = data.max_pages > 1 ? '' : 'none';
				}
				if (typeof jQuery !== 'undefined') {
					jQuery(document).trigger('btr:listings:loaded');
				}
			})
			.catch(function (err) {
				if (err.name === 'AbortError') {
					return;
				}
				clearSkeleton();
				grid.innerHTML = '<p class="no-results">Something went wrong. Please try again.</p>';
			})
			.finally(function () {
				if (controller === requestController) {
					controller = null;
					grid.classList.remove('is-loading');
					grid.removeAttribute('aria-busy');
					clearSkeleton();
				}
			});
	}

	function debounced() {
		clearTimeout(timer);
		timer = setTimeout(function () {
			load(1);
		}, 250);
	}

	// Native changes cover date inputs; selectmenu events cover the styled dropdowns.
	form.addEventListener('change', debounced);
	form.addEventListener('input', debounced);
	if (window.jQuery) {
		window.jQuery(form).on('selectmenuchange', 'select', debounced);
	}
	if (sortEl) {
		sortEl.addEventListener('change', debounced);
		if (window.jQuery) {
			window.jQuery(sortEl).on('selectmenuchange', debounced);
		}
	}

	// Enter dabane par page reload na ho.
	form.addEventListener('submit', function (e) {
		e.preventDefault();
		load(1);
	});

	if (pagination) {
		pagination.addEventListener('click', function (event) {
			var button = event.target.closest('button[data-page]');
			if (button && !button.disabled) {
				load(button.getAttribute('data-page'));
			}
		});
	}

	function reset() {
		clearTimeout(timer);
		Array.prototype.forEach.call(form.elements, function (field) {
			if (!field.name || field.name === 'sort') {
				return;
			}
			if (field.type === 'checkbox' || field.type === 'radio') {
				field.checked = false;
			} else {
				field.value = '';
			}
		});
		if (sortEl) {
			sortEl.value = 'price_asc';
		}
		updateAreasLabel();
		syncAreaMains();
		setAreasOpen(false);
		if (window.jQuery) {
			window.jQuery(form).find('select').each(function () {
				var select = window.jQuery(this);
				if (select.selectmenu && select.selectmenu('instance')) {
					select.selectmenu('refresh');
				}
			});
			if (sortEl) {
				var sort = window.jQuery(sortEl);
				if (sort.selectmenu && sort.selectmenu('instance')) {
					sort.selectmenu('refresh');
				}
			}
		}
		load(1);
	}

	if (resetBtn) {
		resetBtn.addEventListener('click', reset);
		resetBtn.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				reset();
			}
		});
	}

	// Hierarchical multi-select areas dropdown (city + neighborhoods).
	var areasWrap = document.getElementById('btr-areas-dropdown');
	var areasToggle = document.getElementById('btr-f-areas-toggle');
	var areasMenu = document.getElementById('btr-areas-menu');
	var areasLabel = areasToggle ? areasToggle.querySelector('.btr-multi-toggle__label') : null;

	function updateAreasLabel() {
		if (!areasLabel || !areasMenu) {
			return;
		}
		var checked = areasMenu.querySelectorAll('input[name="areas[]"]:checked');
		var labels = [];
		for (var i = 0; i < checked.length; i++) {
			var span = checked[i].parentNode.querySelector('span');
			if (span) {
				labels.push(span.textContent.replace(/^-\s*/, '').trim());
			}
		}
		if (!labels.length) {
			areasLabel.textContent = 'Select area(s)';
		} else if (labels.length > 2) {
			areasLabel.textContent = labels.slice(0, 2).join(', ') + ' +' + (labels.length - 2);
		} else {
			areasLabel.textContent = labels.join(', ');
		}
	}

	function syncAreaMains() {
		if (!areasMenu) {
			return;
		}
		var mains = areasMenu.querySelectorAll('.btr-area-main');
		for (var i = 0; i < mains.length; i++) {
			var group = mains[i].getAttribute('data-group');
			var kids = areasMenu.querySelectorAll('.btr-area-item[data-group="' + group + '"]');
			if (!kids.length) {
				continue;
			}
			var allOn = true;
			for (var k = 0; k < kids.length; k++) {
				if (!kids[k].checked) {
					allOn = false;
					break;
				}
			}
			mains[i].checked = allOn;
			mains[i].indeterminate = !allOn && Array.prototype.some.call(kids, function (el) { return el.checked; });
		}
	}

	function setAreasOpen(isOpen) {
		if (!areasWrap || !areasToggle || !areasMenu) {
			return;
		}
		areasWrap.classList.toggle('is-open', isOpen);
		areasToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		areasMenu.hidden = !isOpen;
	}

	if (areasWrap) {
		areasWrap.addEventListener('click', function (e) {
			e.stopPropagation();
		});
	}
	if (areasToggle && areasMenu) {
		areasToggle.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			setAreasOpen(areasMenu.hidden);
		});
		areasMenu.addEventListener('change', function (e) {
			var target = e.target;
			if (!target || target.type !== 'checkbox') {
				return;
			}
			var group = target.getAttribute('data-group');
			if (target.classList.contains('btr-area-main') && group) {
				var kids = areasMenu.querySelectorAll('.btr-area-item[data-group="' + group + '"]');
				for (var i = 0; i < kids.length; i++) {
					kids[i].checked = target.checked;
				}
				target.indeterminate = false;
			} else if (group) {
				syncAreaMains();
			}
			updateAreasLabel();
		});
		syncAreaMains();
		updateAreasLabel();
	}

	document.addEventListener('click', function () {
		setAreasOpen(false);
	});
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			setAreasOpen(false);
		}
	});

	// Honor filters passed from the homepage search and browser query string.
	if (window.location.search) {
		load(page);
	}
})();